var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoNewChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 27,
    viewBox: "0 0 22 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7207 14.2634C14.6832 14.2632 16.109 10.2956 16.4822 7.03651C16.942 3.02168 15.0434 0 10.7207 0C6.39849 0 4.49895 3.02145 4.95908 7.03651C5.33268 10.2956 6.75802 14.2637 10.7207 14.2634Z",
    fill: "#E4151B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3852 15.9149C19.5127 15.9149 19.6393 15.9187 19.7652 15.9257C19.5766 15.6567 19.3583 15.4194 19.1029 15.2287C18.3415 14.6604 17.3554 14.474 16.4836 14.1314C16.0592 13.9647 15.6792 13.7992 15.3225 13.6106C14.1185 14.931 12.5485 15.6217 10.7202 15.6219C8.89244 15.6219 7.32254 14.9312 6.1187 13.6106C5.76198 13.7992 5.38189 13.9647 4.95762 14.1314C4.08586 14.474 3.09978 14.6604 2.33833 15.2287C1.02151 16.2116 0.681197 18.4226 0.413814 19.9308C0.193149 21.1758 0.0449044 22.4463 0.00163576 23.7109C-0.0318848 24.6904 0.451749 24.8278 1.27123 25.1235C2.29731 25.4935 3.35677 25.7683 4.42336 25.9935C6.4832 26.4285 8.60644 26.7627 10.7205 26.7777C11.7449 26.7704 12.7714 26.6877 13.7917 26.5554C13.0362 25.4608 12.5931 24.1347 12.5931 22.707C12.5931 18.9618 15.64 15.9149 19.3852 15.9149Z",
    fill: "#E4151B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5268 24.1482L21.2526 25.872C21.4235 26.0427 21.7009 26.0427 21.872 25.8718C22.0428 25.7011 22.0426 25.4239 21.8718 25.253L20.147 23.5305C20.494 23.059 20.699 22.4767 20.699 21.8469C20.699 20.2757 19.4223 19 17.8495 19C16.2768 19 15 20.2757 15 21.8469C15 23.4181 16.2768 24.6938 17.8495 24.6938C18.4764 24.6938 19.0561 24.4913 19.5268 24.1482ZM17.8495 19.8751C18.939 19.8751 19.8233 20.7586 19.8233 21.8469C19.8233 22.9352 18.939 23.8189 17.8495 23.8189C16.7602 23.8189 15.8759 22.9352 15.8759 21.8469C15.8759 20.7586 16.7602 19.8751 17.8495 19.8751Z",
    fill: "#E4151B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNewChat);
export default __webpack_public_path__ + "static/media/logoNewChat.72421fd78c05d4e2ffea7270ad0902ea.svg";
export { ForwardRef as ReactComponent };